<template>
  <div>
    <div style="display: flex; justify-content: space-between; margin-bottom: 12px">
      <div style="display: flex; gap: 8px">
        <el-input
          v-model="query.image_id"
          clearable
          placeholder="图片 ID"
          style="width: 260px"
          @change="reload"
        ></el-input>
        <el-button type="primary" :loading="loading" @click="reload">查询</el-button>
      </div>
      <el-button :loading="loading" @click="loadFrequency">刷新</el-button>
    </div>

    <el-table v-loading="loading" :data="frequency_list">
      <el-table-column label="预览图" width="140">
        <template #default="scope">
          <el-image
            v-if="scope.row.thumbnail"
            :src="scope.row.thumbnail"
            fit="cover"
            lazy
            style="width: 100px; height: 100px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="图片 ID" prop="image_id" width="220"></el-table-column>
      <el-table-column label="推荐次数" prop="count" width="120" sortable></el-table-column>
      <el-table-column label="推荐类型">
        <template #default="scope">
          <el-tag v-for="(count, type) in scope.row.types" :key="type" size="small" style="margin: 2px">
            {{ type }}: {{ count }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="上线时间" prop="online_date" width="140"></el-table-column>
      <el-table-column label="最近推荐" prop="updated_at" width="180"></el-table-column>
    </el-table>

    <div style="display: flex; justify-content: space-between; margin-top: 12px">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="query.limit"
        :disabled="loading"
        v-model:current-page="page"
        @current-change="pageChange"
      ></el-pagination>
      <el-select v-model="query.limit" style="width: 100px" :disabled="loading" @change="reload">
        <el-option :value="20"></el-option>
        <el-option :value="50"></el-option>
        <el-option :value="100"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import axios from "ts-axios-new";

export default {
  name: "RecommendFrequency",
  data() {
    return {
      loading: false,
      frequency_list: [],
      total: 0,
      page: 1,
      query: {
        image_id: null,
        limit: 20,
        skip: 0,
      },
    }
  },
  methods: {
    loadFrequency() {
      if (this.query.image_id && this.query.image_id.length !== 24) {
        return
      }
      this.loading = true
      axios.get('/cms/v1/library-recommend-frequency', {params: this.query}).then(res => {
        this.frequency_list = res.data.data.frequencyList
        this.total = res.data.data.total
        this.loading = false
      }).catch(_ => {
        this.loading = false
      })
    },
    reload() {
      this.page = 1
      this.query.skip = 0
      this.loadFrequency()
    },
    pageChange(page) {
      this.page = page
      this.query.skip = (page - 1) * this.query.limit
      this.loadFrequency()
    },
  },
  mounted() {
    this.loadFrequency()
  },
}
</script>
